import { render } from "./UiCarousel.vue?vue&type=template&id=f65d924e"
import script from "./UiCarousel.vue?vue&type=script&lang=js"
export * from "./UiCarousel.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/d/git/workshop/social-friendsquads/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__